import { defineComponent as n, computed as o, openBlock as s, createElementBlock as r, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as h, createStaticVNode as _ } from "vue";
const m = ["viewBox"], p = /* @__PURE__ */ t("mask", { id: "9774e8ff-e8a1-453f-9441-7c3622375f43" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), g = { mask: "url(#9774e8ff-e8a1-453f-9441-7c3622375f43)" }, k = { key: 0 }, u = /* @__PURE__ */ _('<path fill="#d80027" d="M0 0h512v512H0z"></path><circle cx="256" cy="256" r="122.4" fill="#eee"></circle><g fill="#d80027"><path d="m271 209.2 21 29 34.1-11.1-21 29 21 28.9-34-11.1-21 29V267L237 256l34-11z"></path><path d="M283.8 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"></path></g>', 3), v = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ n({
  __name: "tn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), c = o(() => -e.strokeWidth), a = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${l.value} ${l.value}`
    }, [
      p,
      t("g", g, [
        e.flagName ? (s(), r("title", k, d(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  W as default
};
//# sourceMappingURL=tn-2fe3fc67.js.map
